import type { LaborDay2026SaleVariant } from '~/features/promotions/constants/labor-day-2026-sale';
import {
  getLaborDay2026SaleSlideKey,
  getLaborDay2026SaleVariant,
  resolveLaborDay2026SaleVariant,
} from '~/features/promotions/utils/get-labor-day-2026-sale-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const LABOR_DAY_2026_CAMPAIGN_ID = 'labor-day-2026';

export const laborDay2026CampaignCore: Pick<
  PromoCampaignSurfaceRenderers<LaborDay2026SaleVariant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'resolve'
> = {
  id: LABOR_DAY_2026_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getLaborDay2026SaleSlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getLaborDay2026SaleVariant(forcedPromotionId) != null || getLaborDay2026SaleVariant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getLaborDay2026SaleVariant(forcedPromotionId) != null || promotionFetched,
  resolve: ({ forcedPromotionId, promotionId }) => resolveLaborDay2026SaleVariant(forcedPromotionId, promotionId),
};
